import { FileIcon } from 'lucide-react';

export interface AttachmentRowLabels {
  fallback: string;
  view: string;
}

interface AttachmentRowProps {
  fileName?: string;
  fileUrl: string;
  labels: AttachmentRowLabels;
}

export function AttachmentRow({ fileName, fileUrl, labels }: AttachmentRowProps) {
  const isValidUrl =
    fileUrl.startsWith('http://') || fileUrl.startsWith('https://');

  return (
    <a
      href={isValidUrl ? fileUrl : undefined}
      target="_blank"
      rel="noreferrer"
      className="flex items-center gap-2 rounded-lg border border-gray-100 bg-gray-50 px-3 py-2 hover:bg-gray-100 transition-colors"
    >
      <FileIcon size={12} className="shrink-0 text-gray-400" />
      <span className="flex-1 truncate text-xs text-gray-700">
        {fileName ?? labels.fallback}
      </span>
      <span className="shrink-0 text-[10px] font-medium text-indigo-600">
        {labels.view}
      </span>
    </a>
  );
}
